export function getPropertyIDFromHost() {
  let host = window.location.origin;
  if (process.env.NODE_ENV !== "production") {
    host = "localhost";
  }

/* 
NOTE: You also need to give canreports view access to the property in Google Analytics. 
To do this, go to the Admin section of Google Analytics, select the property, 
and then go to the "User Management" section. 

Add this email address: canreports-service-account@canreports.iam.gserviceaccount.com 

with Viewer permissions. 

*/

  const streamPropertyId = "363471233";
  const bodiworksPropertyId = "447973019";
  const fatesCauldronBakeryPropertyId = "461605184";
  const lakesideGoKartsPropertyId = "302314563";
  const bearhousePropertyId = "463869761";
  const socketMatPropertyId = "302285743";
  const sandboxVenturesPropertyId = "467116461";
  const fatesCauldronPropertyId = "492993797";
  const bulletproofBumpersPropertyId = "472195749";
  const lnnprotectionPropertyId = "372356017";
  const chopsuzyartPropertyId = "505389119";
  const essenceCeremoniesPropertyId = "431117024";
  const sipkogroupPropertyId = "518555302";
  const efficientEcoSolutionsPropertyId = "326519928";

  if (
    host.includes("essenceceremonies.ca") ||
    host.includes("essenceceremonies.test.streamdata.ca") ||
    host.includes("essenceceremonies.dev.streamdata.ca")||
    host.includes("essenceceremonies.apps.streamdata.com") 
  ) {
    return essenceCeremoniesPropertyId;
  }
  if (
    host.includes("chopsuzyart.com") ||
    host.includes("chopsuzyart.test.streamdata.com") ||
    host.includes("chopsuzyart.dev.streamdata.com")
  ) {
    return chopsuzyartPropertyId;
  }
  if (
    host.includes("bodiworks.ca") ||
    host.includes("bodiworks.test.streamdata.com") ||
    host.includes("bodiworks.dev.streamdata.com")
  ) {
    return bodiworksPropertyId;
  }

  if (
    host.includes("streamdata.com") ||
    host.includes("sds.test.streamdata.com") ||
    host.includes("sds.dev.streamdata.com")
  ) {
    return streamPropertyId;
  }

  if (
    host.includes("fatescauldronbakery.ca") ||
    host.includes("fatescauldronbakery.test.streamdata.com") ||
    host.includes("fatescauldronbakery.dev.streamdata.com")
  ) {
    return fatesCauldronBakeryPropertyId;
  }

  if (
    host.includes("fatescauldron.ca") ||
    host.includes("fatescauldron.test.streamdata.com") ||
    host.includes("fatescauldron.dev.streamdata.com")
  ) {
    return fatesCauldronPropertyId;
  }

  if (
    host.includes("lakesidegokarts.ca") ||
    host.includes("lakeside.test.streamdata.com") ||
    host.includes("lakeside.dev.streamdata.com")
  ) {
    return lakesideGoKartsPropertyId;
  }

  if (
    host.includes("thebearhouse.ca") ||
    host.includes("bearhouse.test.streamdata.com") ||
    host.includes("bearhouse.dev.streamdata.com")
  ) {
    return bearhousePropertyId;
  }

  if (
    host.includes("socketmat.com") ||
    host.includes("socketmat.test.streamdata.com") ||
    host.includes("socketmat.dev.streamdata.com")
  ) {
    return socketMatPropertyId;
  }

  if (
    host.includes("sandboxventures.ca") ||
    host.includes("sandboxventures.test.streamdata.com") ||
    host.includes("sandboxventures.dev.streamdata.com")
  ) {
    return sandboxVenturesPropertyId;
  }

  if (
    host.includes("bulletproofbumpers.ca") ||
    host.includes("bulletproof.test.streamdata.com") ||
    host.includes("bulletproof.dev.streamdata.com")
  ) {
    return bulletproofBumpersPropertyId;
  }

  if (
    host.includes("lnnprotection.com") ||
    host.includes("lnnprotection.test.streamdata.com") ||
    host.includes("lnnprotection.dev.streamdata.com")
  ) {
    return lnnprotectionPropertyId;
  }

  if (
    host.includes("sipkogroup.ca") ||
    host.includes("sipkogroup.test.streamdata.com") ||
    host.includes("sipkogroup.dev.streamdata.com") ||
    host.includes("sipkogroup.apps.streamdata.com")
  ) {
    return sipkogroupPropertyId;
  }

  if (
    host.includes("efficientecosolutions.ca") ||
    host.includes("efficientecosolutions.com") ||
    host.includes("efficientecosolutions.test.streamdata.com") ||
    host.includes("efficientecosolutions.dev.streamdata.com") ||
    host.includes("efficientecosolutions.apps.streamdata.com")
  ) {
    return efficientEcoSolutionsPropertyId;
  }

  // for local development, use the stream property ID
  if (host.includes("localhost")) {
    return streamPropertyId;
  }
}
